import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../lib/api';

export default function AuthCallback() {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const hash = window.location.hash || '';
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate('/');
      return;
    }
    const session_id = match[1];
    api.post('/auth/google/session', { session_id })
      .then(r => {
        // Persist token in localStorage so subsequent requests carry Bearer auth (CORS-safe)
        if (r.data.session_token) {
          localStorage.setItem('session_token', r.data.session_token);
        }
        window.history.replaceState({}, '', '/dashboard');
        navigate('/dashboard', { replace: true, state: { user: r.data.user } });
      })
      .catch(() => navigate('/'));
  }, [navigate]);

  return (
    <div className="min-h-screen grid place-items-center">
      <div className="text-center">
        <div className="w-12 h-12 border-4 border-forest/20 border-t-forest rounded-full animate-spin mx-auto mb-4" />
        <p className="text-muted-foreground">Signing you in…</p>
      </div>
    </div>
  );
}
